import styled from 'styled-components'

import PickupTimeAddFormUnstyled from 'Containers/Form/City/PickupTimes/PickupTimeAdd/unstyled'

export const PickupTimeAddForm = styled(PickupTimeAddFormUnstyled)`
  margin: 0 -15px;

  .row {
    margin: 0 0 30px 0;
  }

  .row:last-child {
    margin: 0;
  }
  .error-message {
    color: red;
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Form/City/PickupTimes/PickupTimeAdd/index.js